import React from 'react';
import { RhNumberField } from '../../../../../../../../dum';
import {
    GROUP_PRICE,
    ORDER_REQUEST_PRODUCTS,
} from '../order-request-products-columns';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function GroupPriceInput({ index }: { index: number }) {
    // Price is fixed by the account product catalog — read only. Drift from the
    // catalog is surfaced by the does-price-match-catalog validator, which the
    // edit form triggers on mount (RhFormWrapper validateOnMount).
    const INPUT_NAME = `${ORDER_REQUEST_PRODUCTS}.${index}.${GROUP_PRICE}`;

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.group_price)}
            disableGutters
            disabled
        />
    );
}
